export default {
  occupation: 'Ocupación',
  occupationplaceholder: 'Ocupación, profesión u oficio'
}



// WEBPACK FOOTER //
// ./src/App/i18n/strings/components/es.js